import { SentimentBgImage, InfoIcon } from 'assets'
import React, { useEffect, useState } from 'react'
import ProgressBar from 'progressbar.js'
import { useSelector } from 'react-redux'

function DSentimentScore() {
   const [isSentimentScore, setIsSentimentScore] = useState(true)
   const videoRedux = useSelector((state) => state.videoRedux)
   const { loading, videoDetails: videoDetailsData } = videoRedux
   const [globalSentimentScore, setGlobalSentimentScore] = useState(null)

   useEffect(() => {
      if (videoDetailsData?.global_sentiment_score) {
         let rr = videoDetailsData?.sentiment_score - videoDetailsData?.global_sentiment_score
         setGlobalSentimentScore(rr.toFixed(1))
      } else {
         setGlobalSentimentScore(null)
      }

      return () => {}
   }, [videoDetailsData])

   const getText = (value) => {
      return `<div class='text-center'> <span class='score-value text-white'> ${videoDetailsData?.sentiment_score} </span>   </div>`
   }

   useEffect(() => {
      const bar = new ProgressBar.SemiCircle('#chart-container', {
         strokeWidth: 15,
         trailColor: '#FFFFFF4D',
         trailWidth: 15,
         easing: 'easeInOut',
         duration: 1400,
         svgStyle: null,
         text: {
            value: '',
            alignToBottom: false,
            className: 'progressbar__label at-dashboard'
         },
         step: (state, bar) => {
            const value = bar.value()

            // Simulate gradient from #98FF23 (lime green) to #27D089 (teal green)
            const start = { r: 152, g: 255, b: 35 } // #98FF23
            const end = { r: 39, g: 208, b: 137 } // #27D089

            const r = Math.round(start.r + (end.r - start.r) * value)
            const g = Math.round(start.g + (end.g - start.g) * value)
            const b = Math.round(start.b + (end.b - start.b) * value)

            const strokeColor = `rgb(${r}, ${g}, ${b})`

            bar.path.setAttribute('stroke', strokeColor)
            bar.path.setAttribute('fill', 'none')

            const percentValue = Math.round(value * 100)
            if (percentValue === 0) {
               bar.setText('')
            } else {
               bar.setText(getText(percentValue))
            }

            bar.text.style.color = strokeColor
         }
      })
      if (bar) {
         if (videoDetailsData?.sentiment_score) {
            bar.animate(videoDetailsData?.sentiment_score / 100)
         } else {
            bar.animate(0)
         }
      }

      return () => {
         bar.destroy() // Cleanup on component unmount
      }
   }, [isSentimentScore, videoDetailsData])

   return (
      <div
         style={{
            backgroundImage: `url(${SentimentBgImage})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center'
         }}>
         <div className="card">
            <div className="sentiment-score-section">
               <div className="d-flex justify-content-between align-items-center">
                  <h4 className="channel-score-title">Video Sentiment Score</h4>
               </div>

               <>
                  <div className="progress-bar-section">
                     <div id="chart-container"></div>
                     <div className="progress-bar-labels">
                        <span className="progress-label start">0</span>
                        <span className="progress-label end">100</span>
                     </div>
                  </div>

                  {videoDetailsData?.global_sentiment_score ? (
                     <div
                        className={`sentiment-desc ${
                           globalSentimentScore >= 0 ? '' : 'negative-line'
                        }`}>
                        <span className="at-text-light video-sentiment-text">
                           This video has {globalSentimentScore} points{' '}
                           {globalSentimentScore >= 0 ? 'higher ' : 'lower '}
                           than the channel sentiment score
                        </span>
                     </div>
                  ) : null}
               </>
            </div>
         </div>
      </div>
   )
}

export default DSentimentScore
